import './styles/LoadSimple.css'

const LoadSimple=()=>{
    return(
        <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <svg  className='loadSimple' viewBox="25 25 50 50">
  <circle className='circleLoadSimple' r="20" cy="50" cx="50"></circle>
</svg>
        </div>
    )
}

export default LoadSimple